"use client";

import * as React from "react";
import clsx from "clsx";
import { Minus as DashIcon } from "lucide-react";
import { OTPInput, OTPInputContext } from "input-otp";

const InputOTP = ({ className, containerClassName, ...props }: React.ComponentProps<typeof OTPInput>) => (
  <OTPInput
    containerClassName={clsx("flex items-center gap-2 has-[:disabled]:opacity-50", containerClassName)}
    className={clsx("disabled:cursor-not-allowed", className)}
    {...props}
  />
);

const InputOTPGroup = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div className={clsx("flex items-center", className)} {...props} />
);

const InputOTPSlot = ({ index, className, ...props }: React.ComponentProps<"div"> & { index: number }) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];

  return (
    <div
      className={clsx(
        "border-input relative flex h-9 w-9 items-center justify-center border-y border-r text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        isActive && "ring-ring z-10 ring-1",
        className
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="bg-foreground h-4 w-px animate-caret-blink duration-1000" />
        </div>
      )}
    </div>
  );
};

const InputOTPSeparator = ({ ...props }: React.ComponentProps<"div">) => (
  <div role="separator" {...props}>
    <DashIcon />
  </div>
);

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator };
